import { $document } from '@umu/umu-dom';
import { IDocDraftCommentData } from '@umu/umu-types';
import { unhtml, unescapeHtml } from '@umu/umu-util';

const getSubmitContent = (commentData: IDocDraftCommentData[]) => {
    let html = '';
    commentData.forEach((comment: IDocDraftCommentData) => {
        if (comment.quote) {
            html += '<blockquote>' + comment.quote.replace(/\n/g, '<br/>') + '</blockquote>';
        }
        if (comment.content) {
            comment.content = unhtml(comment.content.trim());
            comment.content = comment.content.replace(/\n/g, '<br/>');
            html += '<p>' + comment.content + '</p>';
        }
    });
    return html;
};

const buildNoteData = (html: string = '') => {
    const emptyRet = [{} as IDocDraftCommentData];
    if (!html) {
        return emptyRet;
    }

    const ret: IDocDraftCommentData[] = [];
    const fragment = $document.createElement('div');
    fragment.innerHTML = html;
    const list = [].slice.call(fragment.children);
    for (let i = 0; i < list.length; i++) {
        const el = list[i];
        const item = {
            quote: '',
            content: '',
        };
        // @ts-ignore
        const nodeType = el.nodeName.toUpperCase();
        if (nodeType === 'BLOCKQUOTE') {
            // @ts-ignore
            item.quote = el.innerHTML;

            // 看看下一个是不是p标签
            const nextEl = list[i + 1];
            // @ts-ignore
            if (nextEl && nextEl.nodeName.toUpperCase() === 'P') {
                // @ts-ignore
                item.content = nextEl.innerHTML;
                i++;
            }
        } else {
            // @ts-ignore
            item.content = unescapeHtml((el.innerHTML || '').replace(/<br\/?>/g, '\n'));
        }
        ret.push(item);
    }
    return ret.length ? ret : emptyRet;
};

const isNoteDataEmpty = (data: IDocDraftCommentData[]) => {
    if (!data) {
        return false;
    }

    const length = data.length;
    const firstComment = data[0];
    if (length === 1 && !firstComment.content && !firstComment.quote) {
        return true;
    } else {
        return false;
    }
};

export default {
    getSubmitContent,
    buildNoteData,
    isNoteDataEmpty,
};
